import orderInstance from '../instance'

const updateWaiterSettings = (module, { logoutTime, discount }) => {
  return orderInstance.put(`/waiterSettings/${module}`, { logoutTime, discount })
}

export default updateWaiterSettings
